export default "__VITE_ASSET__Bnh73I9X__"